/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    interface ISelectOption {
        value: string;
        text: string;
    }

    /**
     * ProbeController class
     */
    export class ProbeController {
        public static $name: string = "probeController";
        public static $inject: string[] = ['probeService',
                                           'networkService',
                                           'networkNodeTypeService',
                                           'networkNodeService',
                                           'portScannerJobService',
                                           'ModalService',
                                           '$location',
                                           '$timeout',
                                           '$scope',
                                           '$sce',
                                           'messageTranslationsService'];

        public probes: Models.IPaginatedList<Models.IProbe>;
        public probeFormModel: Application.Models.Probe;
        public probeNetworkNodes: Models.NetworkNode[];
        public showIframe: string = "";
        public networks: Models.INetwork[];

        public paginationSize: number;
        public paginationPage: number;

        private selectize: Selectize.IApi<number, ISelectOption>;

        /**
         * Constructor of the class.
         */
        constructor(private probeService: Application.Services.ProbeService,
                    private networkService: Application.Services.NetworkService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private portScannerJobService: Application.Services.PortScannerJobService,
                    private modalService: ngModal.IModalService,
                    private $location: ng.ILocationService,
                    private $timeout: ng.ITimeoutService,
                    private $scope: ng.IScope,
                    private $sce: ng.ISCEService,
                    private messageTranslationsService: Services.MessageTranslationsService ) {
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            
            this.initData();
            this.selectize = undefined;
            this.loadSelectize();
            this.$scope.$on('$destroy', () => {
                if (this.selectize)
                    this.selectize.destroy();
            });
        }

        /**
         * Save a new probe or a modification on a existing one into and change the view to the last page available.
         */
        public saveProbe(probe: Models.IProbe): void {
            if (probe !== undefined) {
                this.probeService.saveProbe(probe)
                    .then(() => {
                        this.changePageNumber(this.probes.page.totalPages - 1);
                        $('#saving-spinner').css({display: 'none'});
                    })
                    .catch(() => {
                        $('#saving-spinner').css({display: 'none'});
                        this.messageTranslationsService.alertOnError("Something was wrong");
                    });
            }
        }

        /**
         * Delete a given probe and move the view to the first page.
         */
        public deleteProbe(probe: Models.IProbe): void {
            this.probeService
                .deleteProbe(probe)
                .then (() => {
                    this.changePageNumber(0);
                    $('#saving-spinner').css({display: 'none'});
                });
        }

        /**
         * Change the list view to another a given page.
         * @param {number} page - The page number to show
         */
        public changePageNumber(page: number): void {
            this.paginationPage = page;
            this.loadProbes();
        }

        /**
         * Change to page 0 when the user changes the paginationSize property on the corresponding select element.
         */
        public changePageSize(): void {
            this.paginationPage = 0;
            this.loadProbes();
        }

        /**
         * Create a modal from the view easily passing the title and the elemen
         */
        public launchProbeModal(title: string, element: Models.IProbe): void {

            let self: ProbeController = this;
            let copy: Models.Probe = element === undefined ? Models.Probe.Empty() : Models.Probe.Copy(element);

            this.modalService.showModal({
                templateUrl: Application.Controllers.ProbeModalController.templateURL,
                controller: Application.Controllers.ProbeModalController.$name,
                inputs: {
                    title: title,
                    probe: copy,
                    networks: this.networks,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ProbeModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Models.IProbe) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        self.saveProbe(result);
                    }
                });
            });
        }


        /**
         * Launch a modal when attempting to delete a probe from the list
         */
        public deleteProbeModal(probe: Models.IProbe): void {
            let self: ProbeController = this;
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE PROBE',
                    description: "This action cannot be undone.",
                    name: probe.name,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        self.deleteProbe(probe);
                    }
                });
            });
        }

        public loadJobs(probeHref: string): void {
            this.$location.path("/admin/probes/" + Common.Utils.idFromHref(probeHref) + "/jobs");
        }

        /**
         * Retrieve the network nodes and set the pagination properties.
         */
        private loadProbes(): void {
            $('#saving-spinner').css({display: 'block'});
            let paginationSize: number = (this.paginationSize === -1) ? 10 : this.paginationSize;
            this.probeService
                .getAllPaginatedProbesPromise(this.paginationPage, paginationSize, Models.Probe.getDefaultOrderColumn())
                .then((probes: Models.IPaginatedList<Models.IProbe>) => {
                    if (probes.elements.length === 0 && this.paginationPage > 0) {
                        this.paginationPage--;
                        this.loadProbes();
                    }
                    this.probes = probes;
                    if (this.probes.page.totalPages === 0)
                        this.probes.page.totalPages = 1;
                    $('#saving-spinner').css({display: 'none'});
                });
        }

        /**
         * Initiliaze data
         */
        private initData(): void {
            this.paginationPage = 0;
            this.paginationSize = -1;
            this.loadProbes();
            this.networkService.getAllNetworks(
                (messages: Application.Models.INetwork[]) => {
                    this.networks = messages;
                });
        }

        private loadSelectize(): void {
            if (this.selectize !== undefined)
                this.selectize.destroy();
            let $select: JQuery = $('#select-page-size').selectize({
                labelField: 'text',
                valueField: 'value',
                maxItems: 1,
                onChange: (paginationSize: number): void => {
                    let firstTime: boolean = this.paginationSize === -1;
                    this.paginationSize = paginationSize;
                    this.paginationPage = 0;
                    if (!firstTime) this.loadProbes();
                },
                options: [
                    { value: 10, text: '10 probes per page'},
                    { value: 20, text: '20 probes per page'},
                    { value: 50, text: '50 probes per page'},
                    { value: 100, text: '100 probes per page'},
                ],
            });
            this.selectize = $select[0].selectize;
            this.selectize.setValue(10);

        }
    }
}